/** Social links for Ethereum México (ETHMX2026 footer, etc.). */
export const ETHMEX_SOCIAL_LINKS = [
  { id: "x", href: "https://x.com/ethereum_mexico", icon: "x-icon.svg" },
  { id: "telegram", href: "https://t.me/ethmexico", icon: "telegram-icon.svg" },
  {
    id: "linkedin",
    href: "https://www.linkedin.com/company/ethereum-mexico-comunidad/",
    icon: "linkedin-icon.svg",
  },
  {
    id: "youtube",
    href: "https://www.youtube.com/@ethereummexico/streams",
    icon: "youtube-icon.svg",
  },
  {
    id: "instagram",
    href: "https://www.instagram.com/ethereum_mexico/",
    icon: "ig-icon.svg",
  },
];
